import { useQuery } from 'react-query'
import settings from '../../components/settings'

const useAppointment = (id, includeCustomerContext = false) =>
  useQuery(
    id && ['appointment', id, includeCustomerContext],
    () => {
      const url = new URL(
        `${settings.badaAppointmentApiUrl}/appointment/${id}/`
      )
      url.searchParams.append('brand', settings.brand)
      if (includeCustomerContext) {
        url.searchParams.append('includeCustomerContext', true)
      }
      return fetch(url.toString()).then((res) => res.json())
    },
    { retry: 2 }
  )

export default useAppointment
